var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewZealand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 434 434",
    width: 434,
    height: 434,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "newZealand-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #012169 } \n\t\t.s1 { fill: #ffffff } \n\t\t.s2 { fill: #c8102e } \n\t\t.s3 { fill: #c7202f } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m217 0.6c119.5 0 216.4 96.9 216.4 216.4 0 119.5-96.9 216.4-216.4 216.4-119.5 0-216.4-96.9-216.4-216.4 0-119.5 96.9-216.4 216.4-216.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m23.2 120.7l32.9-16.5v48.2h52.8v-48.1l96.3 48.1h35.3v-17.7l-69.8-34.9h69.8v-52.8h-70.1l70.2-35.1v-10q-2.9-0.3-5.9-0.6-2.9-0.2-5.9-0.4-2.9-0.1-5.9-0.2-2.9-0.1-5.9-0.1c-9.5 0-18.9 0.6-28.1 1.8l-80 40v-12.9c-36.8 21.3-66.7 53-85.7 91.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m35.1 99.7h18.2l-25.9 12.9q0.9-1.6 1.8-3.3 1-1.6 2-3.2 0.9-1.6 1.9-3.2 1-1.6 2-3.2zm181.9-99.1q5.2 0 10.4 0.2l-92.3 46.2h-23.5l91.9-46q1.6-0.1 3.3-0.2 1.7 0 3.4-0.1 1.7 0 3.4-0.1 1.7 0 3.4 0zm-174.6 88.6q5.7-7.8 12.1-15.1 6.4-7.3 13.5-14 7-6.7 14.6-12.7 7.6-6 15.7-11.3v21.4h142.2v31.7h-142.2v63.2h-31.7v-63.2zm198.3 63.2l-105.6-52.7h23.6l81.9 40.9v11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m360.8 108.7l15-10.9h-18.6l-5.7-17.7-5.8 17.7h-18.6l15.1 10.9-5.8 17.7 15.1-10.9 15 10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m357.6 107.7l9.9-7.2h-12.3l-3.7-11.7-3.8 11.7h-12.3l9.9 7.2-3.8 11.6 9.9-7.1 9.9 7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m423.4 163.7l2.9-2q-1.1-3.8-2.2-7.6h-3.8l-5.2-15.8-5.1 15.8h-16.5l13.4 9.7-5.1 15.7 13.3-9.7 13.4 9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m420.3 162.8l5.2-3.8-0.6-2.2h-6.5l-3.3-9.8-3.2 9.8h-10.1l8.2 6-3.2 9.7 8.4-6 8.3 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m286.4 183.5l15-10.9h-18.5l-5.8-17.7-5.7 17.7h-18.6l15 10.9-5.7 17.7 15-11 15 11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m283.2 182.5l10-7.3h-12.3l-3.8-11.7-3.8 11.7h-12.2l9.9 7.3-3.8 11.7 9.9-7.2 10 7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m361.8 302.1l16.7-12.1h-20.6l-6.4-19.7-6.5 19.7h-20.6l16.7 12.1-6.4 19.7 16.8-12.2 16.7 12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m358.6 301.1l11.6-8.4h-14.3l-4.4-13.7-4.5 13.7h-14.3l11.5 8.4-4.3 13.6 11.5-8.4 11.7 8.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewZealand);
export default __webpack_public_path__ + "static/media/newZealand.691ff243248587b6397b9113ae2e9deb.svg";
export { ForwardRef as ReactComponent };